<template>
  <div class="cm-discuss">
    <div class="title" v-if="showTitle">
      <img src="@/assets/圆圈.png" />
      <div>三言两语</div>
    </div>

    <CommodityMarketingDiscussReview
      :targetName="targetName"
      :targetId="bean.id"
      :theme="theme"
      @submit="onSubmit"
    />

    <div class="content">
      <div class="title">
        全部评价
        <span>{{retrieve.page.totalCount}}</span>
      </div>

      <div class="null" v-if="retrieve.results.length < 1">
        <div>暂无评价！</div>
        <img src="@/assets/暂无评价.png" v-if="liquor" />
        <img src="/liquor/暂无内容 （金装版）.png" v-else />
      </div>

      <div class="body">
        <div class="comment" v-for="(item, index) in retrieve.results" :key="index">
          <div class="head">
            <img :src="util.getImageUrl(item.head, '100x100')" alt />
          </div>
          <div class="right">
            <div>
              <span class="name">{{item.name}}</span>
              <span class="follow">关注</span>
            </div>

            <div class="point">积分：{{item.point}}</div>
            <div class="discuss">{{item.content}}</div>
            <div class="images">
              <CommodityMarketingDiscussItemImages
                :images="item.contentImages"
                v-if="item.contentImages"
              />
              <CommodityMarketingDiscussItemVideos
                :videos="item.contentVideos"
                v-if="item.contentVideos"
              />
            </div>
            <div class="footer">
              <span>来自{{item.client}} | 发表于{{util.toDateString(util.toDate(item.replyTime))}} {{util.toTimeString(util.toDate(item.replyTime))}}</span>
              <span class="like-commentary">
                <span class="like" @click="onLike(item)">
                  <img src="@/assets/点赞1.png" v-if="true" />
                  <img src="@/assets/点赞2.png" v-else />
                  {{item.likeNumber}}
                </span>
                <span class="commentary" @click="onReply(item)">
                  <img src="@/assets/评论1.png" v-if="true" />
                  <img src="@/assets/评论2.png" v-else />
                  {{item.replyNumber}}
                </span>
              </span>
            </div>

            <CommodityMarketingDiscussReview
              targetName="comment"
              :targetId="item.id"
              :theme="theme"
              :replyId="item.userId"
              @submit="onSubmit"
              v-if="item.reply"
            />

            <div class="triangle" v-if="item.replyList.length > 0"></div>

            <div class="reply" v-if="item.replyList.length > 0">
              <div class="comment" v-for="(child, index) in item.replyList" :key="index">
                <div class="head">
                  <img :src="util.getImageUrl(child.head, '100x100')" />
                </div>
                <div class="right">
                  <div class="title">
                    <span class="from">{{child.name}}</span>
                    <span>回复</span>
                    <span class="to">{{child.to}}</span>
                  </div>
                  <div class="discuss">{{child.content}}</div>
                  <CommodityMarketingDiscussItemImages
                    :images="child.contentImages"
                    v-if="child.contentImages"
                  />
                  <CommodityMarketingDiscussItemVideos
                    :videos="child.contentVideos"
                    v-if="child.contentVideos"
                  />
                  <div class="footer">
                    <span>来自{{child.client}} | 发表于{{util.toDateString(util.toDate(child.replyTime))}} {{util.toTimeString(util.toDate(child.replyTime))}}</span>
                    <span class="like-commentary">
                      <span class="like">
                        <img src="@/assets/点赞1.png" v-if="true" />
                        <img src="@/assets/点赞2.png" v-else />
                        {{child.likeNumber}}
                      </span>
                      <span class="commentary" @click="onReply(child)">
                        <img src="@/assets/评论1.png" v-if="true" />
                        <img src="@/assets/评论2.png" v-else />
                        {{child.replyNumber}}
                      </span>
                    </span>
                  </div>
                  <CommodityMarketingDiscussReview
                    targetName="comment"
                    :targetId="item.id"
                    :theme="theme"
                    :replyId="child.userId"
                    @submit="onSubmit"
                    v-if="child.reply"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="retrieve.page.totalCount"
      :page-size="retrieve.page.numPerPage"
      :current-page="retrieve.page.pageNum"
      @current-change="onCurrentChange"
    ></el-pagination>
  </div>
</template>

<script>
import CommodityMarketingDiscussReview from "./CommodityMarketingDiscussReview";
import CommodityMarketingDiscussItemImages from "./CommodityMarketingDiscussItemImages";
import CommodityMarketingDiscussItemVideos from "./CommodityMarketingDiscussItemVideos";

export default {
  name: "CommodityMarketingDiscuss",
  components: {
    CommodityMarketingDiscussReview,
    CommodityMarketingDiscussItemImages,
    CommodityMarketingDiscussItemVideos
  },
  props: {
    targetName: {
      type: String
    },
    bean: {
      type: Object
    },
    showTitle: {
      type: Boolean,
      default: true
    },
    theme: {
      type: String,
      default: "normal"
    }
  },
  computed: {
    retrieve() {
      return this.$store.state.user.userComment.getCommentsByTargetWithMe;
    }
  },
  methods: {
    onSubmit(e) {
      this.$emit("submit", e);
    },
    onCurrentChange(e) {
      this.$emit("change", e);
    },
    onLike(e) {
      this.$emit("like", e);
    },
    onReply(e) {
      e.reply = !e.reply;
      this.$emit("reply", e);
    }
  }
};
</script>

<style lang="less" scoped>
.cm-discuss {
  width: 1100px;
  .title {
    margin: 20px 0;
    img {
      display: inline-block;
      width: 12px;
      height: 12px;

      margin-right: 10px;
    }
    div {
      display: inline-block;
      width: 80px;
      height: 28px;
      font-size: 20px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 28px;
    }
  }

  .content {
    .title {
      line-height: 20px;
      color: #333;
      span {
        color: #999;
      }
    }

    .null {
      text-align: center;
      margin: 25px 0;
      img {
        width: 200px;
      }
    }

    .head {
      width: 85px;
      display: inline-block;
      vertical-align: top;
      img {
        width: 62px;
        border-radius: 50%;
      }
    }
    .comment {
      margin-bottom: 20px;
    }
    .right {
      width: 1015px;
      display: inline-block;
      padding-bottom: 20px;
      border-bottom: 1px solid #f4f4f4;

      .name {
        color: #333;
        font-size: 16px;
        font-weight: bold;
        // vertical-align: top;
        margin-right: 10px;
      }

      .follow {
        border-radius: 3px;
        color: white;
        background: #f7b500;
        padding: 2px 10px;
        font-size: 12px;
        cursor: pointer;
        // vertical-align: top;
      }

      .point {
        margin: 10px 0;
        font-size: 12px;
        color: #848791;
      }

      .discuss {
        width: 100%;
        margin: 20px 0;
        color: #333;
        line-height: 20px;
      }

      .footer {
        color: #848791;
        font-size: 12px;

        .like-commentary {
          float: right;
        }

        .like {
          cursor: pointer;
          img {
            width: 16px;
            margin-right: 5px;
          }
        }
        .commentary {
          cursor: pointer;
          img {
            width: 16px;
            margin: 0 5px;
          }
        }
      }

      .triangle {
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-bottom: 10px solid #f5f5f5;
        margin-left: 20px;
        margin-top: 20px;
        // background: #f5f5f5;
      }
      .reply {
        background: #f5f5f5;
        padding: 20px;

        .right {
          width: 890px;
          vertical-align: top;
          padding-bottom: 0;
          .title {
            margin-top: 0;

            .from {
              width: 48px;
              height: 22px;
              font-size: 16px;
              font-family: PingFangSC-Semibold;
              font-weight: 600;
              color: rgba(51, 51, 51, 1);
              line-height: 22px;
              margin-right: 10px;
            }

            .to {
              width: 70px;
              height: 20px;
              font-size: 14px;
              font-family: PingFang-SC-Regular;
              font-weight: 400;
              color: #1b994f;
              line-height: 20px;
            }
          }
        }
      }
    }
  }

  .el-pagination {
    text-align: center;
    margin: 20px 0;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #1b994f;
    border-color: #1b994f;
  }
}
</style>

